import { canBypassTargetWindow } from "../../../shared/permissions";

export function normalizeProfileList(data) {
  return Array.isArray(data) ? data : data?.data || [];
}

export function buildProfileUpdateBody({
  job_id,
  supervisor_id,
  level_type,
  product_group_ids,
  financial_claims,
  saleoffice_ids,
  customization,
}) {
  const body = {
    job_id: job_id ? parseInt(job_id, 10) : null,
    supervisor_id: supervisor_id ? parseInt(supervisor_id, 10) : null,
    level_type: level_type ? parseInt(level_type, 10) : null,
    product_group_ids,
    financial_claims:
      financial_claims !== "" && financial_claims != null
        ? Number(financial_claims)
        : null,
    saleoffice_ids: Array.isArray(saleoffice_ids) ? saleoffice_ids.map(Number).filter(Number.isFinite) : null,
  };
  if (customization != null) {
    body.customization = customization;
  }
  return body;
}

export function getNotificationPrefs(profile) {
  const notifications = profile?.customization?.notifications || {};
  return {
    email: notifications.email === true,
    sms: notifications.sms === true,
    active: notifications.active === true,
    targetting: notifications.targetting === true,
    targetting_jalali: notifications.targetting_jalali === true,
    targetting_gregorian: notifications.targetting_gregorian === true,
  };
}

export function isSuperuserProfile(profile) {
  if (!profile || typeof profile !== "object") return false;
  const jobId = Number(profile.job_id ?? profile.job_details?.id);
  const national = String(profile.national_code || "").toLowerCase();
  return jobId === 77 || national === "superuser";
}

/** Master "تارگت" switch — no longer a hard gate, see canBypassTargetWindow. */
export function canProfileSetTargets(profile) {
  return isSuperuserProfile(profile) || getNotificationPrefs(profile).targetting;
}

/**
 * Whether the profile may bypass the role targeting window for this calendar.
 * ON → bypass (top priority); OFF → the role window applies (targeting stays enabled).
 */
export function canProfileSetTargetsForCalendar(profile, calendarType) {
  return canBypassTargetWindow(profile, calendarType);
}
